import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import LoadingIndicator from './loading-indicator';
import { addressActions, getAddressById }  from  '../../core/address'

export class AdrressByLatLong extends Component {

  componentWillMount() {
   this.props.loadAddress( new Map({
       lat: this.props.lat,
       lng: this.props.lng,
     }), this.props.addressId )
  }

  componentWillUpdate(nextProps, nextState) {

  }

  render() {
    const { dataAddress, isPending, lat, lng } = this.props

    if ( isPending ){
      return (<LoadingIndicator style={{height:"20px", "display": "inline-block"}} />)
    }

    let text = '';
    if (dataAddress && dataAddress.address){
      text = `${dataAddress.address.road} ${dataAddress.address.house_number}`
      text = `${text}, ${dataAddress.address.city} - ${dataAddress.address.state}`
      text = <a target="_blank" href={`https://maps.google.com/?q=${lat},${lng}&z=14`} >{text}</a>
    }

    return ( <span>{ text }</span> );
  }
}

//=====================================
//  CONNECT
//-------------------------------------

const mapStateToProps = (state, props) => {
//console.log(props)
  const dataAddress = getAddressById(state, props.addressId)
  let isPending = true;
  if ( dataAddress )
    isPending = dataAddress.isPending
  return {
    lat: props.lat,
    lng: props.lng,
    dataAddress,
    isPending

  }
};

const mapDispatchToProps = {
  loadAddress: addressActions.loadAddress
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdrressByLatLong);
